export default __webpack_public_path__ + "static/media/XEMP-14.0062fb45.jpg";